import api from '../../../api';

export const getEspLimits = async () => api.get('/email-account/esp-limits');

export const updateMaxSendingLimit = async ({ emailAccountId, limit }) =>
  api.patch(`/email-account/max-sending-limit/${emailAccountId}`, { limit });
